/**
 * Created by Ivan on 10.08.2026
 */

const SeasonCollectionsHelper2 = function (view, season) {
    this.view = view;
    this.season = season || cleverapps.stickersBook2.season;
};

SeasonCollectionsHelper2.prototype.getCollectionIcon = function (index) {
    return bundles.stickers2_book_window.frames[`season2_${this.season}_collection_${index}_png`];
};

SeasonCollectionsHelper2.prototype.getStickerImage = function (collectionIndex, stickerIndex) {
    return bundles[SeasonCollectionsHelper2.getCollectionBundleName(collectionIndex, this.season)]
        .frames[`sticker_${stickerIndex}_png`];
};

SeasonCollectionsHelper2.prototype.getSeasonBundle = function () {
    return bundles[SeasonCollectionsHelper2.getSeasonBundleName(this.season)];
};

SeasonCollectionsHelper2.prototype.getCollectionBundle = function (index) {
    return bundles[SeasonCollectionsHelper2.getCollectionBundleName(index, this.season)];
};

SeasonCollectionsHelper2.getCollectionBundleName = function (index, season) {
    return `season2_${season}_collection_${index}`;
};

SeasonCollectionsHelper2.getSeasonBundleName = function (season) {
    return `stickers2_book_season_${season}`;
};

SeasonCollectionsHelper2.hasCollectionBundle = function (index, season) {
    return !!bundles[SeasonCollectionsHelper2.getCollectionBundleName(index, season)];
};

SeasonCollectionsHelper2.hasSeasonBundle = function (season) {
    return !!bundles[SeasonCollectionsHelper2.getSeasonBundleName(season)];
};

SeasonCollectionsHelper2.getThemeBundleName = function (season) {
    return `stickers2_theme_${season}`;
};

SeasonCollectionsHelper2.getTheme = function (season) {
    const bundle = bundles[SeasonCollectionsHelper2.getThemeBundleName(season)];
    return bundle && bundle.jsons.theme_json;
};

SeasonCollectionsHelper2.getWindowBundles = function (windowBundle, season) {
    return [SeasonCollectionsHelper2.getThemeBundleName(season), `${windowBundle}_${season}`].filter((name) => bundles[name]);
};
